import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";
import { RestMethod } from "app/_helpers/ApiConfig/RestMethod";
import { CallApi } from "app/_helpers/CallApi/CallApi";
import { DDMMYYYYFormat, DDMMYYYYHHMMAFormat } from "app/_helpers/dateHelper";
import { CURRENT_SEVERITY } from "app/_pages/_healthSafetyEnvironment/IncidentManagement/CONSTANTS";
import { VFL_STATUS_VIEW } from "app/_pages/_healthSafetyEnvironment/VFL/CONSTANTS";

export const getAllIncidents = async (filter) => {
  try {
    let url = "/global-configuration/ehs-module/all-incident-details?";

    if (filter) url += filter;

    const response = await RestMethod.GET(url);

    const {
      status,
      message,
      data: { incidentDetails, roles },
    } = response.data;

    return {
      status,
      message,
      data: {
        incidentDetails: incidentDetails?.map((row) => ({
          ...row,
          severity: CURRENT_SEVERITY(row),
          createdAtView: DDMMYYYYHHMMAFormat(row.createdAt),
          siteName: row?.site?.name,
          departmentName: row?.department?.name,
          areaName: row?.area?.name,
        })),
        roles,
      },
    };
  } catch (error) {
    console.error("Error detected while fetching data from api");
    return null;
  }
};

export const downloadIncidentReportsBulk = async (data) => {
  try {
    let url = URL_CONFIG.DEV_URL + "global-configuration/ehs-module/incident-report-zip";
    const token = localStorage.getItem("jwt_token");
    console.log("data", data);
    fetch(url, {
      method: "post",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.blob())
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(new Blob([blob]));
        // console.log(new Blob([blob]));
        // window.open(url)
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `incident-reports.zip`);

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
      });

    return;
  } catch (error) { }
};
export const downloadVflReportsBulk = async (data) => {
  try {
    let url = URL_CONFIG.DEV_URL + "global-configuration/ehs-module/vfl-report-zip";
    const token = localStorage.getItem("jwt_token");
    console.log("data", data);
    fetch(url, {
      method: "post",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.blob())
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(new Blob([blob]));
        // console.log(new Blob([blob]));
        // window.open(url)
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `reports.zip`);

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
      });

    return;
  } catch (error) {
    console.error("Error detected while fetching data from api");
    return null;
  }
};

export async function getVFL(filter) {
  let url = "/global-configuration/ehs-module/vlf" + (filter ? `?${filter}` : "");
  const result = await CallApi(url, "GET");

  const { status, message, data = [] } = result;

  return {
    status,
    message,
    data: data?.map((d, index) => {
      return {
        ...d,
        sid: index + 1,
        vflScheduledDateTimeView: DDMMYYYYFormat(d.vflScheduledDateTime),
        mineName: d?.siteData?.name,
        vflStatusView: VFL_STATUS_VIEW[d?.vflStatus],
        areaName: d?.ehs_area_of_operations?.name,
        roId: d?.siteData?.id,
      };
    }),
  };
}
export const downloadVflExcelReports = async (data) => {
  try {
    let url = URL_CONFIG.DEV_URL + "global-configuration/ehs-module/vfl-excel-file";
    const token = localStorage.getItem("jwt_token");
    console.log("data", data);
    fetch(url, {
      method: "post",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.blob())
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(new Blob([blob]));
        // console.log(new Blob([blob]));
        // window.open(url)
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `reports.xlsx`);

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
      });

    return;
  } catch (error) {
    console.error("Error detected while fetching data from api");
    return null;
  }
};
